/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Guides_KickerInputs */

const en_wc_guides_kicker = /** @type {(inputs: Wc_Guides_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The WordCraft field guide`)
};

/**
* | output |
* | --- |
* | "The WordCraft field guide" |
*
* @param {Wc_Guides_KickerInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_guides_kicker = /** @type {((inputs?: Wc_Guides_KickerInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Guides_KickerInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_guides_kicker(inputs)
});
export { wc_guides_kicker as "wc.guides.kicker" }